var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { Link } from "react-router-dom";
import { COMPONENT_STRINGS } from "../../constants";
import { openExternal } from "../../utils/openExternal";
var EXTERNAL_LINKS = {
    CONTACT: "https://www.sjdh.pe.gov.br/fale-conosco/",
    OMBUDSMAN: "https://www.sjdh.pe.gov.br/transparencia/informacoes-institucionais/ouvidoria/",
    TRANSPARENCY: "https://www.sjdh.pe.gov.br/transparencia-2/",
};
export var SecondaryFooter = function () {
    var LINKS = COMPONENT_STRINGS.SECONDARY_FOOTER.LINKS;
    return (_jsx("div", __assign({ className: "w-full bg-white border-t border-gray-200 py-4 px-4 sm:px-6 lg:px-8 font-inter" }, { children: _jsxs("div", __assign({ className: "container mx-auto flex flex-wrap justify-center gap-x-8 gap-y-2" }, { children: [_jsx(Link, __assign({ to: "/complaint/tracking", className: "text-sm text-gray-600 hover:text-blue-700 font-medium transition-colors" }, { children: LINKS.PROTOCOL })), _jsx(Link, __assign({ to: "/sobre", className: "text-sm text-gray-600 hover:text-blue-700 font-medium transition-colors" }, { children: LINKS.ABOUT })), _jsx("a", __assign({ href: EXTERNAL_LINKS.CONTACT, target: "_blank", rel: "noopener noreferrer", className: "text-sm text-gray-600 hover:text-blue-700 font-medium transition-colors", onClick: function (e) {
                        e.preventDefault();
                        openExternal(EXTERNAL_LINKS.CONTACT);
                    } }, { children: LINKS.CONTACT })), _jsx("a", __assign({ href: EXTERNAL_LINKS.OMBUDSMAN, target: "_blank", rel: "noopener noreferrer", className: "text-sm text-gray-600 hover:text-blue-700 font-medium transition-colors", onClick: function (e) {
                        e.preventDefault();
                        openExternal(EXTERNAL_LINKS.OMBUDSMAN);
                    } }, { children: LINKS.OMBUDSMAN })), _jsx("a", __assign({ href: EXTERNAL_LINKS.TRANSPARENCY, target: "_blank", rel: "noopener noreferrer", className: "text-sm text-gray-600 hover:text-blue-700 font-medium transition-colors", onClick: function (e) {
                        e.preventDefault();
                        openExternal(EXTERNAL_LINKS.TRANSPARENCY);
                    } }, { children: LINKS.TRANSPARENCY }))] })) })));
};
